import * as classnames from 'classnames';
import * as React from 'react';

import { ImageLogoDefault, ImageLogoGrey, ImageLogoWhite } from 'images/index';

import './Logo.scss';

interface AvailableLogo {
  [key: string]: string;
}

interface LogoProps {
  className?: string;
  modifier?: 'default' | 'grey' | 'white';
}

export class Logo extends React.Component<LogoProps, {}> {
  private logo: AvailableLogo;

  constructor(props: LogoProps) {
    super(props);

    this.logo = {
      default: ImageLogoDefault,
      grey: ImageLogoGrey,
      white: ImageLogoWhite
    };
  }

  render() {
    const { className, modifier } = this.props;
    const logoFileName = modifier ? this.logo[modifier] : this.logo.default;
    return (
      <div className={classnames('logo__container', className)}>
        <img className="logo__image" alt="logo" src={logoFileName}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Logo/Logo.tsx